import React from "react";
import { T } from "../../../hooks/useTranslate";
import { useMixPanel } from "../../../hooks/useMixPanel";
import { useAuth } from "../../../hooks/useAuth.js";
import { Stack, Typography } from "@mui/material";
import { GotoOldOfficeButton } from "./GotoOldOfficeButton";
import styles from "./backToOldOfficeStyles";

import { OfficeBox } from "../../../components/OfficeBox";


const BackToOldOfficeContent = () => {
  const { logEvent } = useMixPanel();
  const { userInfo } = useAuth();

  const handleGotoOldOffice = (evt) => {
    // trigger mixpanel event to record going back to old office
    logEvent("backto_oldoffice", {
      location: "dashboard",
      click_type: "need_oldoffice"
    });
  };

  const getOldOfficeURL = () => {
    return `${process.env.REACT_APP_OLD_OFFICE}/#/login/sl/${btoa(userInfo.token)}`;
  }

  return (
    <OfficeBox>
      <Stack style={styles.oldOfficeStack} p={1} gap="1.5px" data-test-id={`backto-oldoffice-module`}>
        <Typography style={styles.oldOfficeText} variant="h4" data-test-id="backto-oldoffice--header">
          <T>head_backto_oldoffice</T>
        </Typography>
        <GotoOldOfficeButton
            styles={styles}
            oldOfficeURL={getOldOfficeURL()}
            handleGotoOldOffice={handleGotoOldOffice}
            enableGotoOldOffice={true}
            />
      </Stack>
    </OfficeBox>
  );
};

export { BackToOldOfficeContent };
